import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  wrapper: {
    padding: 20,
    maxWidth: 1000,
    margin: 'auto',
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
})

function GridWrapper(props) {
  const { classes, variant, bgImage, theme, children } = props
  return (
    <div className={classes.root} style={{
      backgroundColor: theme.palette.bg[variant].main,
      color: theme.palette.bg[variant].text,
      backgroundImage: bgImage,
    }}>
      <Grid container spacing={24} className={classes.wrapper}>
        {children}
      </Grid>
    </div>
  )
}

GridWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(GridWrapper)


// WEBPACK FOOTER //
// ./src/components/GridWrapper.js